<climb-header class="app-header"></climb-header>

<main class="app-body">
    <router-outlet></router-outlet>
</main>
